// Changelog
//2017-10-04 - Domenico & Kim - Card 784 - SO Uplift on predefined channels only
//
var CalculationController = (function () {
    function CalculationController($state, settings, env, socket, $scope, Dialog, admin, notify) {
        var _this = this;
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.admin = admin;
        this.notify = notify;
        this.isSaving = false;
        this.isTrue = true;
        this.tables = ['Bonus', 'Bonus Off', 'Sales Order Uplift', 'Sales Order Uplift Off', 'GPP Uplift', 'SO Uplifted Channels', 'Exchange Rates'];
        this.showHistory = false;
        this.newRate = {};
        this.newChannel = {}; //Card 784 - Kim Janneck
        this.curidx = -1;
        this.isSaving = false;
        this.selectedTable = 0;
        this.dataLoaded = false;
        this.socket.forward('admin.calculation.query', this.$scope);
        this.$scope.$on('socket:admin.calculation.query', function (event, data) {
            _this.dataLoaded = true;
            if (data.error) {
                return _this.notify.error("Unable to load table data => " + data.error);
            }
            _this.data = data.data[0];
            // console.info(this.data);
            _this.historyData = data.data[1];
            if (data.data[2]) {
                if (_this.selectedTable !== 4) {
                    _this.countries = data.data[2];
                }
                else {
                    _this.currencies = data.data[2].map(function (obj) {
                        return obj.CURRENCY;
                    });
                    _this.currencies.unshift('');
                }
            }
        });
        this.socket.forward('admin.calculation.insertRate', this.$scope);
        this.$scope.$on('socket:admin.calculation.insertRate', function (event, data) {
            _this.newRate.currency = undefined;
            _this.newRate.fromUsd = undefined;
            _this.newRate.toUsd = undefined;
            _this.isSaving = false;
            if (data.error) {
                return _this.notify.error("Unable to insert new rate => " + data.error);
            }
            else {
                _this.data.unshift(data.rate);
                return _this.notify.success('Inserted successfully.');
            }
        });
        // Card 784 Insert top
        // Card 784: inserting a new channel
        this.socket.forward('admin.calculation.insertChannel', this.$scope);
        this.$scope.$on('socket:admin.calculation.insertChannel', function (event, data) {
            _this.newChannel.channelLetter = undefined;
            _this.isSaving = false;
            if (data.error) {
                return _this.notify.error("Unable to insert new channel => " + data.error);
            }
            else {
                _this.data.unshift(data.channel);
                return _this.notify.success('Inserted successfully.');
            }
        });
        // Card 784: withdrawing a channel.
        this.socket.forward('admin.calculation.withdrawChannel', this.$scope);
        this.$scope.$on('socket:admin.calculation.withdrawChannel', function (event, data) {
            for (var i = 0; i < _this.data.length; i++) {
                if (_this.compareChannels(_this.data[i], data.channel) === 0) {
                    _this.historyData.unshift(_this.data[i]);
                    _this.data.splice(i, 1);
                    break;
                }
            }
            _this.isSaving = false;
            if (data.error) {
                return _this.notify.error("Unable to withdraw channel => " + data.error);
            }
            else {
                _this.data.unshift(data.channel);
                return _this.notify.success('Withdrawn successfully.');
            }
        });
        // Card 784 Insert bottom
        this.socket.forward('admin.calculation.withdrawRate', this.$scope);
        this.$scope.$on('socket:admin.calculation.withdrawRate', function (event, data) {
            for (var i = 0; i < _this.data.length; i++) {
                if (_this.compareRates(_this.data[i], data.rate) === 0) {
                    _this.historyData.unshift(_this.data[i]);
                    _this.data.splice(i, 1);
                    break;
                }
            }
            _this.isSaving = false;
            if (data.error) {
                return _this.notify.error("Unable to withdraw rate => " + data.error);
            }
            else {
                _this.data.unshift(data.rate);
                return _this.notify.success('Withdrawn successfully.');
            }
        });
        // Card 1030 - Edit a bonus listener for autorefresh web page
        this.socket.forward('admin.calculation.updateBonus', this.$scope);
        this.$scope.$on('socket:admin.calculation.updateBonus', function (event, data) {
            _this.isSaving = false;
            if (data.error) {
                return _this.notify.error("Unable to update bonus => " + data.error);
            }
            else {
                _this.data[_this.curidx] = data;
                return _this.notify.success('Update successful! Press F5 to refresh data.');
            }
        });
        // End of Card 1030 - Edit a bonus listener
    } // end of Constructor
    // Card 784 Insert top
    CalculationController.prototype.compareChannels = function (channel1, channel2) {
        /*
        Card 784: Make make sure removal of channel rown in in active table in frontend is performed and it appears in history table.
        */
        if (channel1.CHANNEL < channel2.CHANNEL) {
            return -1;
        }
        if (channel1.CHANNEL > channel2.CHANNEL) {
            return 1;
        }
        if (channel1.STARTDATE < channel2.STARTDATE) {
            return -1;
        }
        if (channel1.STARTDATE > channel2.STARTDATE) {
            return 1;
        }
        if (channel1.ENDDATE < channel2.ENDDATE) {
            return -1;
        }
        if (channel1.ENDDATE > channel2.ENDDATE) {
            return 1;
        }
        return 0;
    };
    // Card 784 Insert bottom
    CalculationController.prototype.compareRates = function (rate1, rate2) {
        if (rate1.CURRENCY < rate2.CURRENCY) {
            return -1;
        }
        if (rate1.CURRENCY > rate2.CURRENCY) {
            return 1;
        }
        if (rate1.STARTDATE < rate2.STARTDATE) {
            return -1;
        }
        if (rate1.STARTDATE > rate2.STARTDATE) {
            return 1;
        }
        if (rate1.ENDDATE < rate2.ENDDATE) {
            return -1;
        }
        if (rate1.ENDDATE > rate2.ENDDATE) {
            return 1;
        }
        if (rate1.FROMUSD < rate2.FROMUSD) {
            return -1;
        }
        if (rate1.FROMUSD > rate2.FROMUSD) {
            return 1;
        }
        if (rate1.TOUSD < rate2.TOUSD) {
            return -1;
        }
        if (rate1.TOUSD > rate2.TOUSD) {
            return 1;
        }
        return 0;
    };
    CalculationController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getData',
                data: {
                    table: this.selectedTable,
                    countries: true
                },
                script: 'admin/calculationtables',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    CalculationController.prototype.switchTable = function () {
        this.dataLoaded = false;
        this.data = undefined;
        this.historyData = undefined;
        var data = {
            table: this.selectedTable
        };
        if (this.selectedTable === 4) {
            if (this.currency) {
                data.currency = this.currency;
            }
            if (this.validDate) {
                var mm = this.validDate.getMonth() + 1; // getMonth() is zero-based
                var dd = this.validDate.getDate();
                data.validDate = [this.validDate.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
            }
            if (!this.currencies) {
                data.countries = true;
            }
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: data,
                email: this.env.user.email,
                function: 'getData',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
    };
    // Card 1030 Insert top
    CalculationController.prototype.editBonus = function (idx) {
        var _this = this;
        this.curidx = idx;
        // console.info(this.data[idx]);
        var items = {
            bonusBundle: {
                priority: this.data[idx]['PRIORITY'],
                country: this.data[idx]['COUNTRY'],
                license: this.data[idx]['LICENSE'],
                revenueStreamCode: this.data[idx]['REVENUE_STREAM_CODE'],
                goe: this.data[idx]['GOE'],
                incentive: this.data[idx]['INCENTIVE'],
                isu: this.data[idx]['ISU'],
                material: this.data[idx]['MATERIAL'],
                customerDesignation: this.data[idx]['CUSTOMER_DESIGNATION'],
                bonus: this.data[idx]['BONUS'],
                startDate: new Date(this.data[idx]['STARTDATE']),
                endDate: new Date(this.data[idx]['ENDDATE']),
                bpId: this.data[idx]['BPID'],
                ibmId: this.data[idx]['IBMID'],
                solution: this.data[idx]['SOLUTION'],
                newclient: this.data[idx]['NEWCLIENT'],
                focus: this.data[idx]['FOCUS'],
                growth: this.data[idx]['GROWTH'],
                sales: this.data[idx]['SALES'],
                engagement: this.data[idx]['ENGAGEMENT'],
                ctl: this.data[idx]['CTL']
            }
        };
        this.Dialog.updateValidForm(undefined, items, 'bonus-edit.html').then(function (dResult) {
            // console.info(items.bonusBundle);
            items.bonusBundle.startDate = items.bonusBundle.startDate.getFullYear() + '-' + (items.bonusBundle.startDate.getMonth() + 1) + '-' + items.bonusBundle.startDate.getDate();
            items.bonusBundle.endDate = items.bonusBundle.endDate.getFullYear() + '-' + (items.bonusBundle.endDate.getMonth() + 1) + '-' + items.bonusBundle.endDate.getDate();
            _this.isSaving = true;
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: _this.data[idx],
                    changes: items.bonusBundle,
                    email: _this.env.user.email,
                    function: 'updateBonus',
                    script: 'admin/calculationtables',
                    token: _this.env.user.token
                }
            });
        });
        return;
    };
    // Card 1030 Insert bottom
    // Card 784 Insert top
    CalculationController.prototype.addChannel = function () {
        //Card 784: adding a channel to the table in the front-end.
        if (!this.newChannel.channelLetter || this.newChannel.channelLetter.length !== 1) {
            var items = {
                icon: 'ERROR',
                message: 'Invalid Channel letter',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        var startDate;
        if (this.newChannel.startDate) {
            var mm = this.newChannel.startDate.getMonth() + 1; // getMonth() is zero-based
            var dd = this.newChannel.startDate.getDate();
            startDate = [this.newChannel.startDate.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
        }
        else {
            var items = {
                icon: 'ERROR',
                message: 'Invalid start date.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        var endDate;
        if (this.newChannel.endDate) {
            var mm = this.newChannel.endDate.getMonth() + 1; // getMonth() is zero-based
            var dd = this.newChannel.endDate.getDate();
            endDate = [this.newChannel.endDate.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
        }
        else {
            var items = {
                icon: 'ERROR',
                message: 'Invalid end date.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    channel: this.newChannel.channelLetter,
                    startDate: startDate,
                    endDate: endDate
                },
                email: this.env.user.email,
                function: 'insertChannel',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
        this.isSaving = true;
    };
    CalculationController.prototype.withdrawChannel = function (i) {
        //Card 784: removing a channel from the table (to history) by setting an enddate to yesterday.
        this.isSaving = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: this.data[i],
                email: this.env.user.email,
                function: 'withdrawChannel',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
    };
    // Card 784 Insert bottom
    CalculationController.prototype.addRate = function () {
        if (!this.newRate.currency || this.newRate.currency.length !== 3) {
            var items = {
                icon: 'ERROR',
                message: 'Invalid currency code.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        if (isNaN(Number(this.newRate.fromUsd))) {
            var items = {
                icon: 'ERROR',
                message: 'Invalid USD to Local value.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        if (isNaN(Number(this.newRate.toUsd))) {
            var items = {
                icon: 'ERROR',
                message: 'Invalid Local to USD value.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        var startDate;
        if (this.newRate.startDate) {
            var mm = this.newRate.startDate.getMonth() + 1; // getMonth() is zero-based
            var dd = this.newRate.startDate.getDate();
            startDate = [this.newRate.startDate.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
        }
        else {
            var items = {
                icon: 'ERROR',
                message: 'Invalid start date.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        var endDate;
        if (this.newRate.endDate) {
            var mm = this.newRate.endDate.getMonth() + 1; // getMonth() is zero-based
            var dd = this.newRate.endDate.getDate();
            endDate = [this.newRate.endDate.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
        }
        else {
            var items = {
                icon: 'ERROR',
                message: 'Invalid end date.',
                title: 'Saving Error'
            };
            this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) { return; });
            return;
        }
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {
                    currency: this.newRate.currency,
                    endDate: endDate,
                    fromUsd: this.newRate.fromUsd,
                    startDate: startDate,
                    toUsd: this.newRate.toUsd
                },
                email: this.env.user.email,
                function: 'insertRate',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
        this.isSaving = true;
    };
    CalculationController.prototype.withdrawRate = function (i) {
        this.isSaving = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: this.data[i],
                email: this.env.user.email,
                function: 'withdrawRate',
                script: 'admin/calculationtables',
                token: this.env.user.token
            }
        });
    };
    CalculationController.$inject = ['$state', 'settings', 'env', 'socket', '$scope', 'Dialog', 'admin', 'notify'];
    return CalculationController;
}());
var CalculationComponent = (function () {
    function CalculationComponent() {
        this.templateUrl = 'calculation-view.html';
        this.controllerAs = 'vm';
        this.controller = CalculationController;
    }
    return CalculationComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg')
        .icon('invalid', '/public/icons/ic_highlight_off_black_24px.svg')
        .icon('save', '/public/images/ic_save_black_24px.svg');
})
    .component('viewCalculationSection', new CalculationComponent());

//# sourceMappingURL=calculation.view.component.js.map
